module.exports = __webpack_public_path__ + "static/media/branch-detail-960.c43be5b5.jpg";